module.exports = __webpack_public_path__ + "img/menu-icon.a239408c.svg";